<template>
<div>
    <div class="form-container ou-donation-form">
        <div class="holder">
            <PaymentForm>
                <FormSection title="Payment Details">
                  <FormRow inline>
                    <FormCol width="half" field="accountID" />
                  </FormRow>
                  <FormRow inline>
                   <FormCol field="firstName" />
                    <FormCol field="lastName" />
                  </FormRow>                
                  <FormRow inline>
                    <FormCol field="email" />
                    <FormCol field="phone" />
                  </FormRow>     
                  <FormRow inline>
                      <Consent privacy="https://www.ou.org/privacy-policy/"/>
                  </FormRow>                               
                </FormSection>
               <FormSection title="Payment Information">
                <FormRow inline>
                  <FormCol field="amount" />
                  <div class="radio-container">                    
                    <FormLabel class="radio-inline">
                        <input type="radio" name="currency" id="currency-usd" :checked="form.currency == 'USD'" @click="setValue('currency', 'USD')"> US Dollars
                    </FormLabel>
                    &nbsp;
                    <FormLabel class="radio-inline">
                        <input type="radio" name="currency" id="currency-cad" :checked="form.currency == 'CAD'" @click="setValue('currency', 'CAD')"> Canadian Dollars
                    </FormLabel>                   
                  </div>
                </FormRow>
                <FormRow inline>
                  <FormCol field="card"  :showLabel="false"/>
                </FormRow>
               </FormSection>
                <FormSection title="Billing Information" >
                    <DonorAddress />
                </FormSection>
                <FormRow>
                    <PaymentButton/>
                </FormRow>
            </PaymentForm>
        </div>
    </div>
</div>
</template>

<script lang="ts">
import { defineComponent, watch } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form';

export default defineComponent({
  setup() {
    const { form, setValue, getValue } = usePaymentForm()

    watch(() => getValue('gateway'), (gateway) => {
      if (gateway == 'SensePassCardknox') {
        setValue('gateway', 'SensePassCardknoxVelocity');
      }

    });

    return {
      form,
      setValue,
    }
  }
});
</script>

<style scoped lang="scss">
.top-bar {
  background: #dee4ea;
  padding: 15px 20px 0;
  border-bottom: 1px solid #cfd5dc;

  .container {
    @media only screen and (min-width: 720px) {
      display: flex;
      justify-content: center;
      max-width: 1000px;
      margin: auto;
    }
  }
  select {
    @media only screen and (min-width: 720px) {
      margin: 0 10px 15px;
      max-height: 26px;
      font-size: 14px;
    }
    margin-bottom: 15px;
    background: white;
  }
}

.radio-container {
  padding-top: 20px;
  @media only screen and (min-width: 720px) {
    padding-top: 40px;
  }
}
</style>
